import React from "react";
import { ButtonPresenter, PresenterProps } from "./Button";

type Props = PresenterProps;

export const Button: React.FC<Props> = (props) => {
  return <ButtonPresenter {...props}></ButtonPresenter>;
};
